import React, { useState, useEffect } from 'react';
import { Drawer, Input, Textarea, Button, Tag } from 'tdesign-react';

const CMP_PROMPT_PRESETS = [
  { label: '精确匹配', value: '精确匹配，忽略前后空格。' },
  { label: '数值等价', value: '数值等价即可，忽略千分位逗号、货币符号与单位。' },
  { label: '语义一致', value: '语义一致即视为通过，允许近义词与表述差异。' },
  { label: '日期归一化', value: '日期归一化为 YYYY-MM-DD 后比较是否相等。' },
];

/**
 * 字段高级配置抽屉
 * 用于配置字段的 字段key、字段prompt（抽取提示）、GT值（标准答案）、比对规则prompt
 */
function FieldConfigDrawer({ visible, fieldData, onClose, onConfirm }) {
  const [formData, setFormData] = useState({
    KeyName: fieldData?.KeyName || '',
    KeyPrompt: fieldData?.KeyPrompt || '',
    KeyExpectedValue: fieldData?.KeyExpectedValue || '',
    KeyAuditPrompt: fieldData?.KeyAuditPrompt || '',
  });

  useEffect(() => {
    if (visible && fieldData) {
      setFormData({
        KeyName: fieldData.KeyName || '',
        KeyPrompt: fieldData.KeyPrompt || '',
        KeyExpectedValue: fieldData.KeyExpectedValue || '',
        KeyAuditPrompt: fieldData.KeyAuditPrompt || '',
      });
    }
  }, [visible, fieldData]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleConfirm = () => {
    onConfirm && onConfirm(formData);
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Drawer
      visible={visible}
      onClose={handleCancel}
      header={
        <span>
          字段高级配置 · <span style={{ color: '#4a70ff' }}>{fieldData?.KeyName || ''}</span>
        </span>
      }
      size="medium"
      footer={
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <Button variant="outline" onClick={handleCancel}>
            取消
          </Button>
          <Button theme="primary" onClick={handleConfirm}>
            确定
          </Button>
        </div>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {/* 字段 key */}
        <div>
          <div style={{ marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: 500 }}>字段 key</div>
          <Input
            value={formData.KeyName}
            onChange={(val) => handleChange('KeyName', val)}
            placeholder="请输入字段名称"
          />
        </div>

        {/* 字段 prompt（抽取提示） */}
        <div>
          <div style={{ marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: 500 }}>字段 prompt（抽取提示）</div>
          <Textarea
            value={formData.KeyPrompt}
            onChange={(val) => handleChange('KeyPrompt', val)}
            placeholder="如需提升字段抽取效果；可以添加字段的描述，比如相近词、详细描述"
            rows={3}
          />
        </div>

        {/* 分隔线 */}
        <div style={{ borderTop: '1px solid #e8eaed', paddingTop: '16px' }}>
          <div style={{ fontSize: '14px', color: '#4a70ff', fontWeight: 500, marginBottom: '16px' }}>
            ⚠ 高级评测配置
          </div>

          {/* GT 值（标准答案） */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: 500 }}>GT 值（标准答案）</div>
            <Input
              value={formData.KeyExpectedValue}
              onChange={(val) => handleChange('KeyExpectedValue', val)}
              placeholder="请输入字段真值，用于比对验证"
            />
          </div>

          {/* 比对规则 prompt */}
          <div>
            <div style={{ marginBottom: '8px', fontSize: '14px', color: '#333', fontWeight: 500 }}>比对规则 prompt</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '8px' }}>
              {CMP_PROMPT_PRESETS.map((preset) => (
                <Tag
                  key={preset.label}
                  theme="default"
                  variant="light"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleChange('KeyAuditPrompt', (formData.KeyAuditPrompt ? formData.KeyAuditPrompt + '' : '') + preset.value)}
                >
                  {preset.label}
                </Tag>
              ))}
            </div>
            <Textarea
              value={formData.KeyAuditPrompt}
              onChange={(val) => handleChange('KeyAuditPrompt', val)}
              placeholder="请输入比对规则prompt，用于结果比对"
              rows={3}
            />
          </div>
        </div>
      </div>
    </Drawer>
  );
}

export default FieldConfigDrawer;
